<template>
  <div class="table-right flex-a-center">
    <div class="time-text">
      <span class="timeTextSpan" v-for="(item, index) of d" :key="'d' + index">
        {{ item }}
      </span>
      <span class="timeTextSpan1">天</span>
      <span class="timeTextSpan" v-for="(item, index) of h" :key="'h' + index">
        {{ item }}
      </span>
      <span class="timeTextSpan1">时</span>
      <span class="timeTextSpan" v-for="(item, index) of m" :key="'m' + index">
        {{ item }}
      </span>
      <span class="timeTextSpan1">分</span>
      <span class="timeTextSpan" v-for="(item, index) of s" :key="'s' + index">
        {{ item }}
      </span>
      <span class="timeTextSpan1">秒</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Countdown',
  props: {
    endTime: {} // 接收得最后时间 2021-12-17 16：29：20
  },
  data() {
    // 这里存放数据
    return {
      d: '00',
      h: '00',
      m: '00',
      s: '00',
      timer: null
    }
  },
  watch: {
    endTime: {
      handler(e) {
        if (e) {
          let self = this
          clearInterval(this.timer)
          this.timer = setInterval(function () {
            self.init()
          }, 1000)
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    let self = this
    self.init()
    clearInterval(this.timer)
    this.timer = setInterval(function () {
      self.init()
    }, 1000)
  },
  //方法集合
  methods: {
    init() {
      let time = this.$moment(this.endTime).diff(this.$moment())
      if (time <= 0) {
        clearInterval(this.timer)
        this.onOver()
        return
      }
      let t = time / 1000
      let d = Math.floor(t / (24 * 3600)) //剩余天数，如果需要可以自行补上
      let h = Math.floor((t - 24 * 3600 * d) / 3600) + d * 24 //不需要天数，把天数转换成小时
      let _h = Math.floor((t - 24 * 3600 * d) / 3600) //保留天数后得小时
      let m = Math.floor((t - 24 * 3600 * d - _h * 3600) / 60)
      let s = Math.floor(t - 24 * 3600 * d - _h * 3600 - m * 60)

      this.d = String(d).length == 1 ? '0' + String(d) : String(d)
      // this.h = String(h).length == 1 ? '0' + String(h) : String(h)
      this.h = String(_h).length == 1 ? '0' + String(_h) : String(_h)
      this.m = String(m).length == 1 ? '0' + String(m) : String(m)
      this.s = String(s).length == 1 ? '0' + String(s) : String(s)
    },
    onOver() {
      this.$emit('over') //倒计时结束得回调
    }
  },
  beforeDestroy() {
    this.timer = null
    clearInterval(this.timer)
  }
}
</script>

<style lang="less" scoped>
.table-right {
  font-size: 12px;
  color: #757e8a;
  .timeTextSpan {
    display: inline-block;
    // width: 14px;
    text-align: center;
    margin-right: 2px;
    font-size: 14px;
    color: #fff2a6;
    font-weight: 500;
    // margin-left: 10px;
  }
  .timeTextSpan1 {
    display: inline-block;
    // width: 14px;
    text-align: center;
    vertical-align: bottom;
    font-size: 14px;
    color: #fff2a6;
    font-weight: 500;
  }

  .time-text {
    display: flex;
    align-items: baseline;
    margin-left: 10px;
  }
}
</style>
